import React, { Component } from 'react';
import {Button, Form, Grid, Header, Image, Loader, Segment, Divider} from 'semantic-ui-react';
import * as profileImage from '../../../assets/profile_image_placeholder.png'
import {getCurrentUserProfile, updateProfileById} from "../../../data/user_api";
import {AGENT_API_URL,DEPOSITARY_INTEGRATION_API_URL} from "../../../constants/api_routes";


class AgentProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            editing: false,
            profileId: JSON.parse(localStorage.getItem('user'))['profile_id'],
            isLoading: true,
            isError: false,
            message: ''
        }
    }

    componentDidMount() {
        this.getProfileData(AGENT_API_URL, this.state.profileId).then((response) => {
            this.setState({isLoading: false})
        }).catch(() => {
            this.setState({isError: true, message: "Something Went wrong. Try again Later"})
        });
    }

    getProfileData = async (url, id) => {
        const {profileData} = await getCurrentUserProfile(url, id);
        this.setState({profile: profileData['agent_profile']});
    };
    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        updateProfileById(AGENT_API_URL, this.state.profileId, formData).then((response) => {
            this.setState({message: response.statusMessage})
        });
        this.setState({editing: false});
    };
    updateProfile = (currentEditingUser) => {
        return (<div>
            <div>
                <Segment>
                    <Header as='h2' textAlign='center'>
                        Update Profile
                    </Header>

                    {this.state.isLoading && <Loader/>}
                    {!this.state.isLoading && <Form onSubmit={this.handleSubmit}>
                        <Grid centered columns={2}>
                            <Grid.Column width={8}>
                                <Grid.Row>
                                    <Header color='blue'>
                                        Profile Details
                                    </Header>
                                    <p></p>
                                    <p style={{fontWeight: 600, fontSize: '1.3rem'}}>Email: <span
                                        style={{fontWeight: 200}}>{currentEditingUser.email}</span>
                                    </p>
                                    <Form.Input label='Name' fluid icon='user' iconPosition='left' placeholder='Name'
                                                type='text' name="name" defaultValue={currentEditingUser.name}
                                                required/>
                                    <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                                placeholder='328659286'
                                                type='text' name="mobile_number"
                                                defaultValue={currentEditingUser['mobile_number']}
                                                required/>
                                    <div className='clearfix-placeholder'>

                                    </div>
                                </Grid.Row>
                                <Grid.Row width={8}>
                                    <Header color='blue'>
                                        Address Details
                                    </Header>
                                    <p></p>
                                    <Form.Input label='Address Line 1' fluid
                                                placeholder='Street'
                                                type='street view'
                                                name="line1"
                                                defaultValue={currentEditingUser.line1}
                                                required/>
                                    <Form.Input label='Address Line 2' fluid
                                                placeholder='Landmark'
                                                type='street view'
                                                name="line2"
                                                defaultValue={currentEditingUser.line2}
                                                required
                                    />
                                    <Form.Group widths={2}>
                                        <Form.Input label='Locality' fluid
                                                    placeholder='Region'
                                                    type='text'
                                                    name="locality"
                                                    defaultValue={currentEditingUser.locality}
                                        />
                                        <Form.Input label='City' fluid
                                                    placeholder='City'
                                                    type='text'
                                                    name="city"
                                                    defaultValue={currentEditingUser.city}
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Input label='Country' fluid
                                                    placeholder='Country'
                                                    type='text'
                                                    name="country"
                                                    defaultValue={currentEditingUser.country}
                                        />
                                        <Form.Input label='Post Code' fluid
                                                    placeholder='C2PN57'
                                                    type='text'
                                                    name="postcode"
                                                    defaultValue={currentEditingUser.postcode}
                                                    required
                                        />
                                    </Form.Group>
                                </Grid.Row>
                                <Grid.Row>
                                    <div className="submit-buttons">
                                        <Button primary fluid>Update User</Button>
                                    </div>
                                </Grid.Row>
                            </Grid.Column>
                        </Grid>
                    </Form>}
                </Segment>
            </div>
        </div>);
    };

    render() {
        const user = this.state.profile;
        return (<div>
            {!this.state.editing && <Grid centered columns={2}>
                <Grid.Column>
                    <Segment>
                        <Image src={profileImage} width='30%' centered/>
                        <Header as='h2' textAlign='center'> {this.state.profile.name} </Header>
                        {this.state.isLoading && <div style={{textAlign:"center"}}><Button loading>Loading Data...</Button></div>}
                        {!this.state.isLoading && <Grid>
                            <Grid.Column width={8}>
                                <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Email: <span
                                    style={{fontWeight: 200}}>{user.email}</span></p>
                                <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Mobile Number: <span
                                    style={{fontWeight: 200}}>{user['mobile_number']}</span></p>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <div style={{fontWeight: 400, fontSize: '1.2rem'}}>
                                    <span style={{fontWeight: 600, fontSize: '1.3rem'}}>Address</span>
                                    <p></p>
                                    <p>
                                        {user.line1} , {user.line2},
                                    </p>
                                    <p>
                                        {user.locality},{user.city},
                                    </p>
                                    <p>
                                        {user.country},{user.postcode}
                                    </p>
                                </div>
                            </Grid.Column>
                        </Grid>}
                        {!this.state.isLoading && <Button primary onClick={(e) => {
                            this.setState({ editing: true })
                        }}>Update Details</Button>}
                    </Segment>

                    {!this.state.isLoading && <Segment>
                        <Header>Depositary Integration</Header>
                        {user.depositary_client_token ?
                            <Button >LINKED</Button> :
                            <Button primary onClick={() => {
                                let url = DEPOSITARY_INTEGRATION_API_URL + `clientId=${user.company_uuid}&authToken=${user.depositary_auth_token}&returnUrl=${encodeURIComponent(window.location.href)}`
                                console.log(url)
                                Object.assign(document.createElement('a'), {
                                    target: '_blank',
                                    href: url
                                }).click()
                            }}>
                                LINK WITH DEPOSITARY ACCOUNT
                            </Button>}
                        <Divider></Divider>
                        {user.depositary_linked_branches && <div>
                            <h4>Linked Branches</h4>
                            <ul>
                                {user.depositary_linked_branches.map((branch) => { return <li key={branch}>{branch}</li> })}
                            </ul></div>}
                    </Segment>}
                </Grid.Column>
            </Grid>}
            {this.state.editing && this.updateProfile(user)}
        </div>);
    }
}

export default AgentProfile;


// WEBPACK FOOTER //
// ./src/views/user/agent/profile.js